import { useState } from 'react';
import { toast } from 'react-toastify';

import PlaybackIcon from '../../assets/svg/PlaybackIcon';
import { TOAST_AUTOCLOSE_TIMEOUT_MS } from '../../constants/notifications';
import { useAuthContext } from '../../hooks';
import { updateRecordingVisibility } from '../../services/recordingVisibilityApi';
import { RecordingOptOutModal } from '../Modals/RecordingOptOutModal';
import { Loader, Switch } from '../Shared';

export const RecordingVisibilityToggle = () => {
  const { recordingVisible, setRecordingVisible } = useAuthContext();
  const [isLoading, setIsLoading] = useState(false);
  const [isConfirmOpen, setIsConfirmOpen] = useState(false);

  // One-way switch: once recordings are turned off, the user can't turn them back on.
  const isDisabled = !recordingVisible;

  const handleChange = () => {
    if (isDisabled) return;

    setIsConfirmOpen(true);
  };

  const handleConfirm = async () => {
    setIsConfirmOpen(false);

    try {
      setIsLoading(true);
      await updateRecordingVisibility(false);
      setRecordingVisible(false);
      toast.success('Call recordings turned off.', {
        position: 'top-right',
        autoClose: TOAST_AUTOCLOSE_TIMEOUT_MS,
      });
    } catch {
      toast.error("Can't update recording visibility. Please try again!", {
        position: 'top-right',
        autoClose: TOAST_AUTOCLOSE_TIMEOUT_MS,
      });
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div className="flex items-center gap-2 rounded-lg px-2.5 py-2">
      <div className="flex items-center gap-2">
        <PlaybackIcon
          className={`w-5 h-5 ${isDisabled ? 'text-white/40' : 'text-brand-300 group-hover:text-white'}`}
        />

        <span
          className={`font-medium text-[16px]/[24px] ${isDisabled ? 'text-white/40' : 'text-white'}`}
        >
          Recordings
        </span>
      </div>

      <div className="grow flex items-center justify-center h-6">
        {isLoading ? (
          <Loader size={24} message="" />
        ) : (
          <Switch
            checked={recordingVisible}
            disabled={isDisabled}
            onChange={handleChange}
          />
        )}
      </div>

      <RecordingOptOutModal
        open={isConfirmOpen}
        onClose={() => setIsConfirmOpen(false)}
        onConfirm={handleConfirm}
      />
    </div>
  );
};
